/* eslint-disable @typescript-eslint/no-unused-vars */
import Swiper from 'swiper/bundle';

/* Selection Cambos */
new Swiper('.selection-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  grid: {
    rows: 1,
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      grid: {
        rows: 1,
      },
    },
    1400: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

/* Selection lire en ce moment */
new Swiper('.read-now-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: false,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

/* post in about */
new Swiper('.about-post-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: false,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

/* Other post */
new Swiper('.other-post-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false,
    },
  },
});

/* Post author post */
new Swiper('.author-articles-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      grid: {
        rows: 1,
      },
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: false,
      grid: {
        rows: 2,
      },
    },
  },
  grid: {
    rows: 1,
    fill: 'row',
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

/* Section categorie */
new Swiper('.section-categorie-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 10,
  centeredSlides: true,
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: false,
    },
  },
  pagination: {
    el: ".swiper-pagination",
  },
});
/* eslint-enable @typescript-eslint/no-unused-vars */
